export const COLLECTION_CONFIGS = {
    deals: {
        label: 'Deals',
        collection: 'deals',
        fields: [
            { key: 'name', label: 'Deal Name', required: true, exportable: true },
            { key: 'company', label: 'Company', required: false, exportable: true },
            { key: 'value', label: 'Value / Amount', required: true, exportable: true },
            { key: 'owner', label: 'Deal Owner', required: true, exportable: true },
            { key: 'stage', label: 'Stage', required: false, exportable: true },
            { key: 'phone', label: 'Phone', required: false, exportable: true },
            { key: 'email', label: 'Email', required: false, exportable: true },
            { key: 'notes', label: 'Notes', required: false, exportable: true },
        ]
    },
    deal_audits: {
        label: 'Deal Audits',
        collection: 'deal_audits',
        fields: [
            { key: 'dealName', label: 'Deal Name / Company', required: true, exportable: true },
            { key: 'amount', label: 'Amount', required: true, exportable: true },
            { key: 'dealDate', label: 'Close Date', required: true, exportable: true },
            { key: 'salesRep', label: 'Sales Rep', required: true, exportable: true },
            { key: 'segment', label: 'Segment', required: false, exportable: true },
            { key: 'paymentType', label: 'Payment Type', required: false, exportable: true },
            { key: 'verdict', label: 'Verdict', required: false, exportable: true },
            { key: 'saleType', label: 'Sale Type', required: false, exportable: true },
            { key: 'servicesPromised', label: 'Service Promised', required: false, exportable: true },
            { key: 'feedbackNotes', label: 'Feedback/Comments', required: false, exportable: true },
            { key: 'status', label: 'Status', required: false, exportable: true },
            { key: 'createdAt', label: 'Created At', required: false, exportable: true },
        ]
    },
    call_audits: {
        label: 'Call Audits',
        collection: 'call_audits',
        fields: [
            { key: 'agent', label: 'Agent Name', required: true, exportable: true },
            { key: 'contact', label: 'Contact Name', required: true, exportable: true },
            { key: 'company', label: 'Company', required: false, exportable: true },
            { key: 'duration', label: 'Duration (Seconds)', required: false, exportable: true },
            { key: 'url', label: 'Audio/Video URL', required: false, exportable: true },
            { key: 'createdAt', label: 'Created At', required: false, exportable: true },
        ]
    },
    lead_audits: {
        label: 'Lead Audits',
        collection: 'lead_audits',
        fields: [
            { key: 'name', label: 'Lead Name', required: true, exportable: true },
            { key: 'companyName', label: 'Company', required: false, exportable: true },
            { key: 'email', label: 'Email', required: false, exportable: true },
            { key: 'phone', label: 'Phone', required: false, exportable: true },
            { key: 'salesRep', label: 'Sales Rep / Owner', required: true, exportable: true },
            { key: 'status', label: 'Status', required: false, exportable: true },
            { key: 'source', label: 'Lead Source', required: false, exportable: true },
            { key: 'createdAt', label: 'Created At', required: false, exportable: true },
        ]
    },
    campaign_audits: {
        label: 'Campaign Audits',
        collection: 'campaign_audits',
        fields: [
            { key: 'campaignName', label: 'Campaign Name', required: true, exportable: true },
            { key: 'clientName', label: 'Client Name', required: true, exportable: true },
            { key: 'pmName', label: 'Project Manager', required: true, exportable: true },
            { key: 'salesRep', label: 'Sales Rep', required: false, exportable: true },
            { key: 'platform', label: 'Platform / Source', required: false, exportable: true },
            { key: 'startDate', label: 'Start Date', required: false, exportable: true },
            { key: 'status', label: 'Status', required: false, exportable: true },
            { key: 'budget', label: 'Budget/Amount', required: false, exportable: true },
            { key: 'createdAt', label: 'Created At', required: false, exportable: true },
        ]
    },
    escalation_cases: {
        label: 'Escalation Cases',
        collection: 'escalation_cases',
        fields: [
            { key: 'companyUrl', label: 'Company Name / URL', required: true, exportable: true },
            { key: 'reportedBy', label: 'Reported By', required: true, exportable: true },
            { key: 'escalationFrom', label: 'Escalated From', required: true, exportable: true },
            { key: 'type', label: 'Type (Internal/External)', required: false, exportable: true },
            { key: 'conflictReason', label: 'Conflict Reason', required: false, exportable: true },
            { key: 'status', label: 'Status', required: false, exportable: true },
            { key: 'createdAt', label: 'Created At', required: false, exportable: true },
        ]
    },
    orders: {
        label: 'Orders',
        collection: 'orders',
        fields: [
            { key: 'companyName', label: 'Company Name', required: true, exportable: true },
            { key: 'clientName', label: 'Client Name', required: true, exportable: true },
            { key: 'clientEmail', label: 'Client Email', required: true, exportable: true },
            { key: 'segment', label: 'Segment', required: false, exportable: true },
            { key: 'monthlyCharges', label: 'Monthly Charges', required: false, exportable: true },
            { key: 'repEmail', label: 'Representative Email', required: false, exportable: true },
            { key: 'createdAt', label: 'Created At', required: false, exportable: true },
        ]
    },
    hubspot_sop: {
        label: 'SOP Tracker',
        collection: 'hubspot_sop',
        fields: [
            { key: 'name', label: 'Lead/Company Name', exportable: true },
            { key: 'ownerName', label: 'Owner', exportable: true },
            { key: 'ownerTeam', label: 'Team', exportable: true },
            { key: 'emailsSent', label: 'Emails Sent', exportable: true },
            { key: 'callsMade', label: 'Calls Made', exportable: true },
            { key: 'leadStatus', label: 'Lead Status', exportable: true },
            { key: 'lastActivityDate', label: 'Last Activity', exportable: true },
            { key: 'ownerAssignedDate', label: 'Assigned Date', exportable: true },
            { key: 'complianceStatus', label: 'SOP Status', exportable: true },
        ]
    }
};
